import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative bg-[#1E2652] pt-24 pb-12 overflow-hidden" }
const _hoisted_2 = { class: "container mx-auto px-6" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "space-y-4" }
const _hoisted_6 = { class: "space-y-4" }
const _hoisted_7 = {
  href: "https://www.instagram.com/padelgo.ma/",
  target: "_blank",
  class: "text-gray-400 hover:text-[#B7E000] transition-colors duration-300 flex items-center"
}
const _hoisted_8 = { class: "border-t border-white/10 pt-8" }
const _hoisted_9 = { class: "flex flex-col md:flex-row justify-between items-center" }
const _hoisted_10 = { class: "text-gray-400 text-sm mb-4 md:mb-0" }

import { InstagramIcon } from 'lucide-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'PageFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"col-span-1 md:col-span-1\" data-v-3527500c><div class=\"flex items-center mb-6\" data-v-3527500c><div class=\"text-2xl font-bold flex items-center\" data-v-3527500c><span class=\"text-white font-light\" data-v-3527500c>Padel</span><span class=\"text-[#B7E000] font-semibold\" data-v-3527500c>Go</span></div></div><p class=\"text-gray-400 mb-6\" data-v-3527500c> Élevez votre expérience de jeu avec PadelGo, l&#39;application de réservation de terrains et de mise en relation de joueurs au Maroc. </p></div>", 1)),
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-white font-semibold mb-6" }, "Liens Rapides", -1)),
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/#features",
                class: "text-gray-400 hover:text-[#B7E000] transition-colors duration-300"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Fonctionnalités")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/contact",
                class: "text-gray-400 hover:text-[#B7E000] transition-colors duration-300"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Contact")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/support",
                class: "text-gray-400 hover:text-[#B7E000] transition-colors duration-300"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Support")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-white font-semibold mb-6" }, "Légal", -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/terms-of-use",
                class: "text-gray-400 hover:text-[#B7E000] transition-colors duration-300"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Conditions Générales d'Utilisation (CGU)")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/terms-of-sale",
                class: "text-gray-400 hover:text-[#B7E000] transition-colors duration-300"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Conditions Générales de Vente (CGV)")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/privacy-policy",
                class: "text-gray-400 hover:text-[#B7E000] transition-colors duration-300"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Politique de Confidentialité")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/legal-notice",
                class: "text-gray-400 hover:text-[#B7E000] transition-colors duration-300"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Mentions légales")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-white font-semibold mb-6" }, "Suivez-nous", -1)),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_7, [
                _createVNode(_unref(InstagramIcon), { class: "w-6 h-6 mr-2" }),
                _cache[9] || (_cache[9] = _createTextVNode(" Instagram "))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(new Date().getFullYear()) + " PadelGo. Tous droits réservés. ", 1)
        ])
      ])
    ])
  ]))
}
}

})